/**
 * Drawer — 侧边抽屉（目录、筛选）
 */

import { ReactNode, useEffect } from 'react';

export interface DrawerProps {
  open: boolean;
  onClose: () => void;
  side?: 'left' | 'right';
  title?: string;
  children: ReactNode;
}

export function Drawer({
  open,
  onClose,
  side = 'right',
  title,
  children,
}: DrawerProps) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-40">
      {/* 遮罩 */}
      <div
        className="absolute inset-0 bg-charcoal/30 backdrop-blur-sm"
        onClick={onClose}
      />
      {/* 抽屉本体 */}
      <div
        className={`absolute top-0 ${side === 'left' ? 'left-0' : 'right-0'} h-full w-80 max-w-[85vw] bg-white dark:bg-warm-dark shadow-lg overflow-y-auto`}
      >
        {title && (
          <div className="flex items-center justify-between px-4 py-3 border-b border-border-warm dark:border-border-warm-dark">
            <h2 className="text-lg font-medium text-charcoal dark:text-charcoal-light">
              {title}
            </h2>
            <button
              onClick={onClose}
              className="text-charcoal/60 hover:text-charcoal dark:text-charcoal-light/60 dark:hover:text-charcoal-light text-xl"
            >
              ✕
            </button>
          </div>
        )}
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
}
